'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextAlignment = require('./TextAlignment');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextAlignment).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}